/* eslint-disable react/prefer-stateless-function */
import React from "react";
import CookieConsent from "react-cookie-consent";
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

class PrivacyPopup extends React.Component {
  render() {
    return (
      <Translation>{tr => (<div>
        <CookieConsent
          location="bottom"
          buttonText={tr('common:legacyOption61')}
          cookieName="wasRead"
          style={{ background: "#c91f27" }}
          buttonStyle={{ color: "#fff", backgroundColor: "#007bff", borderColor: "#007bff", fontSize: "1rem", padding: "0.375rem 0.75rem", borderRadius: "0.25rem" }}
          expires={150}
        >{tr("public:legalText145")} <a href="#" onClick={this.props.showPrivacyModal}> {tr("public:legalText146")}</a>
        </CookieConsent>
      </div>)}</Translation>
    );
  }
}


export default PrivacyPopup;


PrivacyPopup.propTypes = {
  showPrivacyModal: PropTypes.func.isRequired
};
